import getApi from '../../api/apisauceConfig'
import { Contact } from '../../model/Contact'
import { serializeContact } from './mapper/contact.mapper'

export const createContact = (contact: Partial<SafeOmit<Contact, 'id'>>) =>
  getApi().post<Contact>('/contacts', serializeContact(contact))
